












































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { ManualModel } from "../models";

import ManualBlock from "modules/manuals/components/ManualBlock.vue";
import ManualDialog from "modules/manuals/components/ManualDialog.vue";
import RemoveManualDialog from "modules/manuals/components/RemoveManualDialog.vue";
import ManualFilter from "modules/manuals/components/ManualFilter.vue";
import AddManual from "modules/manuals/components/AddManual.vue";
import { SnackbarInterface } from "shared/store/snackbar/state";

const mStore = namespace("manual");
const snackStore = namespace("snackbar");

@Component({
  components: {
    ManualBlock,
    ManualDialog,
    ManualFilter,
    AddManual,
    RemoveManualDialog,
  },
})
export default class Manuals extends Vue {
  @mStore.Getter allManuals!: ManualModel[];
  @mStore.Action fetchManuals!: () => Promise<void>;
  @mStore.Action forceFetchManuals!: () => Promise<void>;
  @snackStore.Mutation setSnackbar!: (payload: SnackbarInterface) => void;

  filteredManuals: ManualModel[] = [];
  timesListChanged = 0;
  reloadFilter = false;

  get editMode(): boolean {
    if (
      this.$route.meta === undefined ||
      this.$route.meta.editMode === undefined
    ) {
      return false;
    }
    return this.$route.meta.editMode;
  }

  dialog = {
    state: false,
    manual: new ManualModel(),
    createNew: false,
  };

  openManualDialog(manual: ManualModel, createNew: boolean): void {
    this.dialog.manual = manual;
    this.dialog.createNew = createNew;
    this.dialog.state = true;
  }

  removeDialog = {
    state: false,
    manual: new ManualModel(),
    createNew: false,
  };

  openRemoveManualDialog(manual: ManualModel): void {
    this.removeDialog.manual = manual;
    this.removeDialog.state = true;
  }

  listChanged(): void {
    this.timesListChanged++;
    this.forceFetchManuals()
      .then(() => {
        this.reloadFilter = true;
      })
      .catch(() => {
        this.setSnackbar({
          text: this.$t("global.errors.default").toString(),
          color: "error",
        });
      });
  }

  mounted(): void {
    this.fetchManuals()
      .then(() => {
        this.filteredManuals = this.allManuals;
      })
      .catch(() => {
        this.setSnackbar({
          text: this.$t("global.errors.default").toString(),
          color: "error",
        });
      });
  }
}
